import React, { useState } from 'react';
import ContentModulesView from './ContentModulesView.js'
import './TrackCard.css';

function TrackCard(props) {
    const [isCollapsed, setCollapsed] = useState(true)

    const handleClick = () => {
        setCollapsed(!isCollapsed)        
    }

    return (
        <div className = "trackcard">            
            <p><b>{props.isCourse ? "Course" : "Track"}: </b><a href={'https://www.codecademy.com/learn/' + props.track.slug} target="_blank" rel="noreferrer">{props.track.title}</a></p>
            <p><b>slug: </b>{props.track.slug}</p>             
            <p><b>Description: </b>{props.track.shortDescription}</p>
            <button onClick={handleClick}>{isCollapsed ? "Expand" : "Hide"} Modules</button>
            <div hidden={isCollapsed}>
                <ContentModulesView modules={props.track.contentModules} parentTrackSlug={props.track.slug}/>
            </div>
        </div>
    )
}

export default TrackCard;